import { render, staticRenderFns } from "./ArrowLeftCollapse.vue?vue&type=template&id=7541fb36&"
import script from "./ArrowLeftCollapse.vue?vue&type=script&lang=js&"
export * from "./ArrowLeftCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports